import { useCallback } from 'react';

export const useClipboard = () => {
    const copyToClipboard = useCallback(async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            return false;
        }
    }, []);

    return { copyToClipboard };
};